import React, {
  useMemo,
  useCallback,
  useState,
  useEffect,
  useRef,
} from 'react';

import {
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  TextField,
} from '@material-ui/core';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';

import { Input, RadioGroup } from '~/components/Form';
import { t } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import api from '~/services/api';

import * as S from './styles';

export default function ConfirmDialog(props) {
  const { onClose, selectedValue, open, handleSubmit } = props;
  const [error, setError] = useState(false);
  const [desabilitado, setDesabilitado] = useState(false);

  const motivoRef = useRef('');

  const estaEmManutencao = useMemo(
    () => selectedValue?.manutencaodvec === 'S',
    [selectedValue]
  );

  const handleClose = () => {
    setError(false);
    onClose();
    motivoRef.current = '';
  };

  const handleManutencao = useCallback(async () => {
    try {
      if (!estaEmManutencao && motivoRef.current.length === 0) {
        setError(true);
        return;
      }

      if (selectedValue.idveiculo) {
        setDesabilitado(true);

        if (estaEmManutencao) {
          await api.put(
            `afericaodvecs/manutencao/retirar/${selectedValue.idveiculo}`
          );
          motivoRef.current = '';
          setDesabilitado(false);
          onClose();
        } else {
          await api.put(
            `afericaodvecs/manutencao/colocar/${selectedValue.idveiculo}/${motivoRef.current}`
          );
          motivoRef.current = '';
          setDesabilitado(false);
          onClose();
        }
      }
    } catch (err) {
      setDesabilitado(false);
      getToastErrors(err);
    }
  }, [selectedValue, setDesabilitado]);

  const handleMotivo = (value) => {
    motivoRef.current = value;
  };

  return (
    <Dialog
      fullWidth
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
      open={open}
    >
      <DialogTitle id="alert-dialog-title">
        {estaEmManutencao
          ? t('s.operacao.afericaodvec.confirmaretirarmanutencaodvec').replace(
              '%s',
              `o Veículo ${selectedValue.idveiculo} - Empresa ${selectedValue.nomeempresaveiculostr}`
            )
          : t('s.operacao.afericaodvec.confirmamanutencaodvec').replace(
              '%s',
              `o Veículo ${selectedValue?.idveiculo} - Empresa ${selectedValue?.nomeempresaveiculostr}`
            )}
      </DialogTitle>
      <DialogContent>
        {!estaEmManutencao && (
          <TextField
            name="motivoiniciomanutencaodvec"
            label={t('s.geral.camposistema.motivoiniciomanutencaodvec')}
            onChange={(value) => handleMotivo(value.target.value)}
            id="outlined-multiline-static"
            multiline
            variant="outlined"
            fullWidth
            error={error}
            minRows={3}
            inputProps={{ maxLength: 100 }}
          />
        )}
        {error && (
          <span style={{ color: 'red' }}>
            {t('s.geral.validacao.campoobrigatorio')}
          </span>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleManutencao}
          disabled={desabilitado}
          color="primary"
        >
          {t('s.geral.botaoconfirmar')}
        </Button>
        <Button onClick={handleClose} color="secondary">
          {t('s.geral.botaocancelar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {};

ConfirmDialog.defaultProps = {};
